import tinycolor from 'tinycolor2';
import { normalizeCssColor } from './proposalRichTextPalette';

/** Deux couleurs CSS équivalentes (hex / rgb / rgba). */
export function cssColorsEqual(a, b) {
  const na = normalizeCssColor(a);
  const nb = normalizeCssColor(b);
  if (!na && !nb) return true;
  if (!na || !nb) return false;
  return tinycolor(na).toRgbString() === tinycolor(nb).toRgbString();
}

/**
 * Couleur de surlignage de la sélection — mark `highlight` uniquement.
 * Pas de repli sur le style calculé : contrairement à la couleur du texte,
 * « pas de mark » veut dire « pas de surlignage », et non « la couleur héritée ».
 * @returns {string|null} couleur CSS normalisée, `null` si non surligné
 */
export function getSelectionHighlightColor(editor) {
  if (!editor || editor.isDestroyed) return null;
  if (!editor.isActive('highlight')) return null;
  const fromMark = editor.getAttributes('highlight')?.color;
  return fromMark ? normalizeCssColor(fromMark) : null;
}

/**
 * Couleur du texte sélectionné : mark Tiptap, sinon style inline, sinon computed.
 * @returns {string|null} couleur CSS normalisée
 */
export function getSelectionTextColor(editor) {
  if (!editor || editor.isDestroyed) return null;

  const fromMark = editor.getAttributes('textStyle')?.color;
  if (fromMark) return normalizeCssColor(fromMark);

  const { view } = editor;
  if (!view) return null;

  try {
    const { from } = editor.state.selection;
    const dom = view.domAtPos(from);
    let el = dom.node;
    if (el.nodeType === Node.TEXT_NODE) el = el.parentElement;
    if (!(el instanceof HTMLElement)) return null;

    let node = el;
    while (node && node !== view.dom) {
      const inline = normalizeCssColor(node.style?.color);
      if (inline) return inline;
      node = node.parentElement;
    }

    return normalizeCssColor(window.getComputedStyle(el).color);
  } catch {
    return null;
  }
}
